// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"a0af688f","703":"015cbe91"}[chunkId] + ".chunk.js";
};